/**
 * The leaderboard as its own screen, for reading outside a room.
 *
 * *** THE SAME BOARD, A DIFFERENT PLACE ***
 * Inside the room it sits in the right column as ambient pressure. Here it
 * is the thing you came to look at, with the viewer's own totals above it —
 * a student checking their standing between study sessions should not have
 * to enter a room to do it.
 */

import { PageHeader, PageStack } from '@/components/ui/Page'
import { useMyProgress } from '@/lib/queries'
import { RoomLeaderboard } from './RoomLeaderboard'
import { hoursMinutes } from './format'
import styles from './LeaderboardPage.module.css'

export function LeaderboardPage() {
  const { data } = useMyProgress()

  return (
    <PageStack>
      <PageHeader
        title="Leaderboard"
        description="Verified study time across every room in your institute."
      />

      <div className={styles.stats}>
        <div className={styles.stat}>
          <span className={styles.figure}>
            {hoursMinutes(data?.today_seconds ?? 0)}
          </span>
          <span className={styles.label}>Today</span>
        </div>
        <div className={styles.stat}>
          <span className={styles.figure}>
            {hoursMinutes(data?.week_seconds ?? 0)}
          </span>
          <span className={styles.label}>This week</span>
        </div>
        <div className={styles.stat}>
          <span className={styles.figure}>
            {hoursMinutes(data?.total_seconds ?? 0)}
          </span>
          <span className={styles.label}>All time</span>
        </div>
        <div className={styles.stat}>
          <span className={styles.figure}>{data?.day_streak ?? 0}</span>
          <span className={styles.label}>
            {/* Named in days because a bare number beside "streak" reads as
                hours in a screen that is otherwise all hours. */}
            {data?.day_streak === 1 ? 'Day streak' : 'Day streak'}
          </span>
        </div>
      </div>

      <div className={styles.boardWrap}>
        <RoomLeaderboard />
      </div>
    </PageStack>
  )
}
